<div class="Site">

  <header class="Site-header" id="header-div">
    <mat-toolbar color="white">
      <mat-toolbar-row class="title-bar">
        <div>
          <div class="mobile-hide"><img routerLink="/home" class="logo-primary"
              src="../assets/FE_Primary_Logo_Green.png"></div>
          <div class="desktop-hide"><img routerLink="/home" class="logo-secondary"
              src="../assets/FE_Secondary_Logo_Green.png"></div>
        </div>
        <div class="title-wrap">
          <span class="title mobile-hide">{{title}}</span>
          <span class="title desktop-hide">{{titleShort}}</span>
        </div>
        <div>
          <app-header-menu></app-header-menu>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </header>

  <div class="Site-content" id="content-div">
    <app-navbar>
      <div class="spinner-container" *ngIf="busyService.busy$ | async">
        <mat-spinner></mat-spinner>
      </div>
      <router-outlet></router-outlet>
    </app-navbar>
  </div>

  <footer class="Site-footer" id="footer-div">
    <mat-toolbar color="accent" class="footer-toolbar">
      <mat-toolbar-row class="footer-toolbar-row">
        <app-footer class="footer"></app-footer>
      </mat-toolbar-row>
    </mat-toolbar>
  </footer>

</div>
